(function($) {
  function productSizeOption() {
    var isProductPage = $('.template-product').length;
    
    if (isProductPage) {
      var sizeIndex = product.options.indexOf('Size');
      var hasSizeOption = sizeIndex !== -1;
      var $productFormButtons = $('.product-form-buttons');
      
      // Disable size selection initially
      if (hasSizeOption) {
        $('input[name="Size"]').prop('checked', false);
        $productFormButtons.addClass('hide');
        
        $productFormButtons.after(`
		  <button class="btn btn--full btn--no-animate select-size">SELECT YOUR SIZE</button>
		`);
        
        // On size select, activate Add to cart
        $(document).on('change', 'input[name="Size"]', function(e) {
          console.log(e);
          var $productFormButtons = $('.product-form-buttons');
          var $selectSizeBtn = $('.select-size');
          $productFormButtons.removeClass('hide');
          $selectSizeBtn.remove();
        });
      }      
    }
  }
  
  $(document).ready(function() {
    productSizeOption();
  });
})(jQuery);